import { employeeUpdateDescription as description } from './description';
import { update as execute } from './execute';

export { description, execute };
